import ReactDOM from 'react-dom';
import './index.css';
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppLocaleProvider } from '@higo/common/lib/features/Locale';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { AppWrapper } from 'AppWrapper';
import { useMicrositeQueryClient } from 'hooks/useMicrositeQueryClient';

const RootProviders = () => {
  const queryClient = useMicrositeQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

ReactDOM.render(
  <StrictMode>
    <BrowserRouter>
      <AppLocaleProvider>
        <RootProviders />
      </AppLocaleProvider>
    </BrowserRouter>
  </StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
